"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgEyeOff = function SvgEyeOff(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M13.707 12.293l22 22a1 1 0 01-1.414 1.414l-4.468-4.466A11.089 11.089 0 0124 33c-3.38 0-6.339-1.632-8.855-4.316a20.492 20.492 0 01-2.25-2.891 15.188 15.188 0 01-.79-1.346 1 1 0 01.014-.92 19.45 19.45 0 014.45-5.544l-4.276-4.276a1 1 0 011.414-1.414zm.436 11.71a18.513 18.513 0 002.462 3.313C18.776 29.632 21.255 31 23.984 31a9.07 9.07 0 004.387-1.214l-2.322-2.321a4 4 0 01-5.514-5.514l-2.548-2.55a17.45 17.45 0 00-3.844 4.602zM24 15c3.38 0 6.339 1.632 8.855 4.316a20.492 20.492 0 012.25 2.891c.385.596.649 1.065.79 1.346a1 1 0 01-.013.918 19.5 19.5 0 01-2.277 3.363 1 1 0 01-1.53-1.288 17.5 17.5 0 001.783-2.548 18.513 18.513 0 00-2.463-3.314C29.224 18.368 26.745 17 23.998 17a8.12 8.12 0 00-1.87.214 1 1 0 11-.456-1.948A10.116 10.116 0 0124 15zm-2.013 9.57a2 2 0 002.57 1.402l-2.53-2.53c-.118.358-.136.749-.04 1.128z",
    id: "eye-off_svg__a"
  }));
};

var _default = SvgEyeOff;
exports["default"] = _default;